exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, "span.badge > span {\n  background-color: #ff3d00;\n  right: 6px;\n  top: 6px;\n  height: 15px;\n  width: 15px;\n  font-size: 0.6rem;\n  color: white; }\n\n.readed-true {\n  color: rgba(0, 0, 0, 0.5) !important; }\n  .readed-true div span,\n  .readed-true div p {\n    color: lightgrey; }\n  .readed-true .notification-created-at {\n    display: block;\n    font-size: 0.5rem; }\n\n.notification-item p {\n  font-size: 0.65rem; }\n\n.circular-progress.mini {\n  width: 24px !important;\n  height: 24px !important;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: auto;\n  position: relative;\n  line-height: auto;\n  font-size: 24px;\n  left: 0px;\n  top: 0px; }\n  .circular-progress.mini svg {\n    margin: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/basic/customIconButton/index.scss
// module id = 1016
// module chunks = 0